import React, { useRef, MouseEvent } from 'react'

export const VIRTUAL_TOUR_ID = 'virtual-tour'
const IFRAME_DEFAULY_HEIGHT = '935'
interface VirtualTourProps {
  embedSrc: string
  iframeClass?: string
  containerClass?: string
  height?: string
}

const VirtualTour: React.FC<VirtualTourProps> = ({
  embedSrc,
  iframeClass = '',
  containerClass = '',
  height = IFRAME_DEFAULY_HEIGHT
}) => {
  const virtualTourIframeRef = useRef<HTMLIFrameElement | null>(null)

  const handleVirtualTourMouseEvents = (event: MouseEvent<HTMLElement>) => {
    const { current: element } = virtualTourIframeRef

    if (!element) {
      return
    }

    if (event.type === 'click') {
      element.style.pointerEvents = 'auto'
    }

    if (event.type === 'mouseout') {
      element.style.pointerEvents = 'none'
    }
  }

  return (
    <div
      className={containerClass}
      onClick={handleVirtualTourMouseEvents}
    >
      <iframe
        onMouseOut={handleVirtualTourMouseEvents}
        ref={virtualTourIframeRef}
        id={VIRTUAL_TOUR_ID}
        height={height}
        className={`pointer-events-none ${iframeClass}`}
        src={embedSrc}
      />
    </div>
  )
}

export default VirtualTour
